import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    staticClass: "transformer",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": _vm.mode !== 'readonly' ? 6 : 12
    }
  }, [_c('p', {
    staticClass: "card-description mt-4"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.transformationDescription')) + "\n      ")]), _c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.transformationDescription2')) + "\n      ")]), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.transformationDescription3'))
    }
  }), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.transformationDescription4'))
    }
  })]), _vm.mode !== 'readonly' ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.sampleScripts')))])]), _c(VExpansionPanelContent, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.findTranformationScripts')))]), _c(VAutocomplete, {
    attrs: {
      "items": [{
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.simple'),
        value: 'simple'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.watt_to_kwatt'),
        value: 'wh_to_kwh'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.celsFahr'),
        value: 'c_to_f'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.fahrCels'),
        value: 'f_to_c'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.batteryPercentage'),
        value: 'battery_v_to_p'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.intBool'),
        value: 'i_to_b'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.aggrFirst'),
        value: 'aggregate_first_value'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.aggrSum'),
        value: 'aggregate_sum'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.aggrAvrg'),
        value: 'aggregate_average'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.aggrMax'),
        value: 'aggregate_max'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.aggrMin'),
        value: 'aggregate_min'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.sumDay'),
        value: 'sum_day'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.sumMonth'),
        value: 'sum_month'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerScripts.ignore_older_data'),
        value: 'ignore_older_data'
      }],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformerTemplates'),
      "hide-details": "",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.selectedTransformerTemplate
    },
    model: {
      value: _vm.transformer.template,
      callback: function ($$v) {
        _vm.$set(_vm.transformer, "template", $$v);
      },
      expression: "transformer.template"
    }
  })], 1)], 1)], 1)], 1), _c(VCol, {
    staticClass: "pt-0 pb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.helperMethods')))])]), _c(VExpansionPanelContent, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.methodsFollowingLiberaries')) + ":\n                "), _c('ul', [_c('li', [_c('em', [_vm._v("lodash")]), _vm._v("\n                    : Array, Object, Collection, Math, String, Lang\n                  ")])])])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _c('core-script-editor', {
    attrs: {
      "script": _vm.currentScript,
      "script-type": "javascript",
      "fixed-payload-type": "JSON",
      "hide-script-type-selector": "",
      "readonly": _vm.mode === 'readonly'
    },
    on: {
      "update:script": _vm.onScriptChange
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };